module.exports = __webpack_public_path__ + "fonts/la-brands-400.908ce19.eot";